export const unaryOperators = [
  'textEmpty',
  'textNotEmpty',
  'isNull',
  'isNotNull',
];
export const nonNumericOperators = [
  'contains',
  'doesNotContain',
  'startsWith',
  'endsWith',
  'textEquals',
  'textDoesNotEqual',
  'isNull',
  'isNotNull',
  'textEmpty',
  'textNotEmpty'
];
